import * as z from 'zod'

import {buildEntrySchemaFor} from '@github-ui/swp-core/schemas/contentful/entry'
import {RichTextSchema} from '@github-ui/swp-core/schemas/contentful/richText'
import {LinkSchema} from '@github-ui/swp-core/schemas/contentful/contentTypes/link'
import {PrimerComponentLabelSchema} from '@github-ui/swp-core/schemas/contentful/contentTypes/primerComponentLabel'
import {safeOptional} from '@github-ui/swp-core/schemas/safe-optional'

import {GenericAssetSchema} from './generic-asset'
import {GenericConditionalCTAsSchema} from './generic-conditional-ctas'
import {GenericCTAGroupSchema} from './generic-cta-group'

export const GENERIC_CONTENT = 'genericContent'

export const GenericContentSchema = buildEntrySchemaFor(GENERIC_CONTENT, {
  fields: z.lazy(() =>
    z.object({
      id: z.string().optional(),
      htmlId: z.string().optional(),
      label: safeOptional(PrimerComponentLabelSchema),
      heading: z.string().optional(),
      subheading: safeOptional(RichTextSchema),
      text: safeOptional(RichTextSchema),
      links: safeOptional(z.array(LinkSchema).max(2)),
      ctas: safeOptional(z.array(GenericCTAGroupSchema)),
      cta: safeOptional(GenericConditionalCTAsSchema),
      media: safeOptional(z.array(GenericAssetSchema)),
      content: safeOptional(z.array(z.any())),
    }),
  ),
})

export type GenericContent = z.infer<typeof GenericContentSchema>
